import card1 from './assets/card1.jpg';
import card2 from './assets/card2.jpg';
import card3 from './assets/card3.jpg';
import card4 from './assets/card4.jpg';
import card5 from './assets/card5.jpg';
import card6 from './assets/card6.jpg';
import card7 from './assets/card7.jpg';

const  carddetail=[
    {
     name:'Hawthorne Apartments',
     price:'50000',
     detail:'100 Hawthorne Dr, Madison, WI 53705',
     img:card1
    },
    {
     name:'Las Vegas Strip',
     price:'60000',
     detail:'Las Vegas Blvd S, Las Vegas, NV 89109',
     img:card2
    },
    {
     name:'Space Needle',
     price:'40000',
     detail:'400 Broad St, Seattle, WA 98109',
     img:card3
    },
    {
     name:'Times Square',
     price:'45000',
     detail:'450 W 141st St, Los Angeles, CA 90061',
     img:card4
    },
    {
     name:'Riverwalk Apartments',
     price:'60000',
     detail:'1850 Riverbend Rd, Dalton, GA 30721',
     img:card5
    },
    {
     name:'Greenwood Apartments',
     price:'70000',
     detail:'2100 W 9th Ave, Amarillo, TX 79106',
     img:card6
    },
    {
     name:'Mountain View Villas',
     price:'65000',
     detail:'450 W 141st St, Los Angeles, CA 90061',
     img:card7
    },
]

export default carddetail;